<template>
	<div>
		<b-table-simple borderless condensed class="text-left d-none d-lg-table">
			<b-tr>
				<b-td rowspan="3" width="1%" class="py-0">
					<b-avatar :src="executive.image_url" size="6rem"></b-avatar>
				</b-td>
				<b-th class="py-0">
					{{executive.name}}
				</b-th>
			</b-tr>
			<b-tr>
				<b-td class="py-0">
					<a :href="'https://api.whatsapp.com/send?phone='+executive.clean_phone" target="_blank" class="text-dark">
						<font-awesome-icon :icon="['fab', 'whatsapp-square']" size="lg" color="rgb(33,176,56)" /> {{executive.phone}}
					</a>
				</b-td>
			</b-tr>
			<b-tr>
				<b-td class="py-0">
					<a :href="'mailto:'+executive.email" target="_blank" class="text-dark">
						<font-awesome-icon :icon="['fas', 'envelope']" size="lg" color="#9A9595" /> {{executive.email}}
					</a>
				</b-td>
			</b-tr>
		</b-table-simple>
		<b-table-simple borderless condensed class="text-center d-lg-none">
			<b-tr class="d-lg-none">
				<b-td class="py-0">
					<b-avatar :src="executive.image_url" size="6rem"></b-avatar>
				</b-td>
			</b-tr>
			<b-tr>
				<b-th class="py-0">
					{{executive.name}}
				</b-th>
			</b-tr>
			<b-tr>
				<b-td class="py-0">
					<a :href="'https://api.whatsapp.com/send?phone='+executive.clean_phone" target="_blank" class="text-dark">
						<font-awesome-icon :icon="['fab', 'whatsapp-square']" size="lg" color="rgb(33,176,56)" /> {{executive.phone}}
					</a>
				</b-td>
			</b-tr>
			<b-tr>
				<b-td class="py-0">
					<a :href="'mailto:'+executive.email" target="_blank" class="text-dark">
						<font-awesome-icon :icon="['fas', 'envelope']" size="lg" color="#9A9595" /> {{executive.email}}
					</a>
				</b-td>
			</b-tr>
		</b-table-simple>
	</div>
</template>
<script>
	export default {
		name: 'ExecutiveAvatar',
		props: {
			executive: {default: {
				name: '',
				phone: '',
				email: '',
				cleanPhone: ''
			}}
		}
	}
</script>
